/**
 * Created by Victor Rojo on 19/10/18.
 */
import { Pipe, PipeTransform } from '@angular/core';
import {I18NService} from "../../shared/i18n/i18n.service";

@Pipe({name: 'CloudNotificationSolvedType'})
export class CloudNotificationSolvedTypePipe implements PipeTransform {

  constructor(private i18nService: I18NService){

  }

  transform(value: number): string {
    let res = "";
    switch (value) {
      case 1:
        res = this.i18nService.get("notification");
        break;
      case 2:
        res = this.i18nService.get("manually");
        break;
      case 3:
        res = this.i18nService.get("time");
        break;
    }
    return res;
  }
}
